export function parseTimecodeToSeconds(value) {
  if (typeof value !== 'string') {
    return value;
  }

  const parts = value.split(':');
  if (parts.length !== 4) {
    return value;
  }

  const [hours, minutes, seconds, frames] = parts.map(Number);
  if ([hours, minutes, seconds, frames].some(Number.isNaN)) {
    return value;
  }

  // Stored markers/custom frames now use seconds; for legacy timecodes, keep whole-second precision.
  return (hours * 3600) + (minutes * 60) + seconds;
}

export function normalizePersistedClips(clips = []) {
  return clips.map(clip => {
    let frames = clip.frames || {};

    // Migrate legacy custom_frames to frames.title
    if (!frames.title && clip.custom_frames?.length) {
      const legacy = clip.custom_frames[0];
      if (legacy?.design_project_id != null) {
        frames = {
          ...frames,
          title: {
            design_project_id: legacy.design_project_id,
            duration: legacy.duration,
            s3_path: legacy.s3_path
          }
        };
      }
    }

    const { custom_frames, ...clipWithoutLegacy } = clip;
    return {
      ...clipWithoutLegacy,
      markers: (clip.markers || []).map(marker => ({
        ...marker,
        time: typeof marker.time === 'number' ? marker.time : parseTimecodeToSeconds(marker.time)
      })),
      frames
    };
  });
}

export function stripMarkerSnapshotsFromClip(clip = {}) {
  const sortedMarkers = (clip.markers || [])
    .slice()
    .sort((a, b) => {
      const leftTime = Number(a?.time);
      const rightTime = Number(b?.time);
      const leftIsFinite = Number.isFinite(leftTime);
      const rightIsFinite = Number.isFinite(rightTime);

      if (!leftIsFinite && !rightIsFinite) {
        return 0;
      }

      if (!leftIsFinite) {
        return 1;
      }

      if (!rightIsFinite) {
        return -1;
      }

      return leftTime - rightTime;
    });

  const { custom_frames, ...clipWithoutLegacy } = clip;
  const strippedFrames = {};
  for (const [frameType, frame] of Object.entries(clip.frames || {})) {
    if (!frame) continue;
    const { thumbnail, ...rest } = frame;
    strippedFrames[frameType] = rest;
  }

  return {
    ...clipWithoutLegacy,
    markers: sortedMarkers.map(marker => {
      const nextMarker = {...marker};
      delete nextMarker.snapshot;
      return nextMarker;
    }),
    frames: strippedFrames
  };
}

export function buildPersistableClipsPayload(clips = []) {
  return (clips || []).map(stripMarkerSnapshotsFromClip);
}
